import React from 'react';

import { StyledBackground } from './GlobalBackground.styles';
import { GlobalBackgroundProps } from './types';

const GlobalBackground: React.FC<GlobalBackgroundProps> = ({ children }) => {
  return <StyledBackground>{children}</StyledBackground>;
};

export default GlobalBackground;
